<template>
  <v-card
    flat
    class="vetalfa-card-grey-border vetalfa-pointer pa-0 timeline-card"
    style="border-left: 4px solid #4caf50; overflow: hidden"
    @click="open"
  >
    <v-row class="ma-0 pa-0" align="center" no-gutters>
      <v-col cols="auto" class="pa-3 d-flex align-center">
        <v-avatar size="36" color="green" class="white--text">
          <v-icon small color="white">{{ mdiPrescription }}</v-icon>
        </v-avatar>
      </v-col>
      <v-col class="pa-3 pl-0">
        <p class="ma-0 subtitle-2 font-weight-bold">
          {{ _getLabel("PRESCRIPTION") }}
        </p>
        <p class="ma-0 caption grey--text text--darken-1">
          {{ formattedDate }}
        </p>
        <p class="ma-0 caption mt-1" style="line-height: 1.3">
          {{ _getLabel("TAB_GUIDES") }}: {{ pageCount }} •
          {{ _getLabel("PRESCRIPTION_ITEM_TOTAL") }}: {{ itemCount }}
        </p>
        <div class="mt-1">
          <v-chip
            x-small
            :color="isSent ? 'success' : 'grey lighten-2'"
            :text-color="isSent ? 'white' : 'grey darken-2'"
          >
            {{ isSent ? _getLabel("SENT") : _getLabel("DRAFT") }}
          </v-chip>
          <v-chip
            v-if="prescription.encounterId"
            x-small
            class="ml-1"
            color="grey lighten-2"
            text-color="grey darken-2"
          >
            {{ _getLabel("ENCOUNTER") }}
          </v-chip>
        </div>
      </v-col>
      <v-col cols="auto" class="pr-2">
        <v-icon x-small color="grey">{{ mdiChevronRight }}</v-icon>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import { mdiChevronRight, mdiPrescription } from "@mdi/js";

export default {
  name: "PrescriptionCard",
  props: {
    prescription: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      mdiChevronRight,
      mdiPrescription,
    };
  },
  computed: {
    /**
     * `shareDate` já vem formatado do backend (texto), então a data numérica
     * exibida e ordenada é sempre o `lastUpdate`.
     */
    isSent() {
      return !!this.prescription.shareDate;
    },
    formattedDate() {
      if (this.prescription.shareDate) return this.prescription.shareDate;
      if (!this.prescription.lastUpdate) return "-";
      return this._getDateFromTimestamp(this.prescription.lastUpdate);
    },
    pages() {
      return this.prescription.pages || [];
    },
    pageCount() {
      return this.pages.length;
    },
    itemCount() {
      return this.pages.reduce(
        (total, page) => total + ((page || []).length || 0),
        0
      );
    },
  },
  methods: {
    open() {
      this.$emit("open", this.prescription);
    },
  },
};
</script>

<style scoped>
.timeline-card {
  background:#fff; border-color:#e5e9f1 !important; transition: box-shadow 0.2s, transform .2s;
}
.timeline-card:hover {
  box-shadow:0 6px 18px rgba(25,49,83,.12) !important; transform:translateY(-1px);
}
</style>
